import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const goodFit = ['The book is already in the world', 'The book supports a real business, not just a royalty stream', 'You have a method, framework, point of view, or body of work', 'The book points toward coaching, consulting, speaking, training, workshops, courses, certification, advisory, events, communities, or team implementation', 'You want the book to keep creating movement after launch'];
const notFit = ['You only want to sell more books', 'You want bestseller, PR, ads, publishing, or ghostwriting help', 'You want a cheap author website', 'You have no downstream offer', 'You want a generic funnel'];
export function FitInvestment() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paper" width="wide" data-id="element-746" data-mp="2rdav4gnxqry2">
      <div className="max-w-3xl" data-id="element-747" data-mp="2wb2kb2x73zyk">
        <Reveal data-id="element-748" data-mp="2wab00o91tonl">
          <Eyebrow data-id="element-749" data-mp="2wbvt09fpszjc">Fit &amp; investment</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-750" data-mp="126jak4sxudyj">
            Built for expert books with
            <br data-id="element-751" data-mp="xdggzwo5v4ic" />
            <span className="italic text-seaglass" data-id="element-752" data-mp="xcyam77sb9wp">real work behind them.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-753" data-mp="ngv7ay175586">
        <Reveal delay={0.1} data-id="element-754" data-mp="nieqoxi5fwe6">
          <div className="h-full rounded-3xl border border-seaglass/40 bg-white p-8 shadow-[0_16px_36px_-24px_rgba(139,168,159,0.7)] md:p-9" data-id="element-755" data-mp="1l4c78pcyxrnh">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass" data-id="element-756" data-mp="1g6ke5s0l7zhp">
              Good fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-757" data-mp="1b891zamtlcwb">
              {goodFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-758" data-mp="173sy1ewrofjq">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-seaglass text-xs font-bold text-white" data-id="element-759" data-mp="3vwwtokt8glqx">
                    ✓
                  </span>
                  <span className="leading-relaxed text-text" data-id="element-760" data-mp="3tbfnihqtnvld">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.15} data-id="element-761" data-mp="255vo67m5cj9">
          <div className="h-full rounded-3xl border border-gray-200 bg-paper-dark p-8 md:p-9" data-id="element-762" data-mp="23bg77f42cmk">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-763" data-mp="3jg5hzk17t62u">
              Not a fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-764" data-mp="3al7nw9mbzn9x">
              {notFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-765" data-mp="3ajms6goa5yah">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-xs font-bold text-gray-500" data-id="element-766" data-mp="3fdqzx25deacm">
                    ✕
                  </span>
                  <span className="leading-relaxed text-text-muted" data-id="element-767" data-mp="35mo0s5w045fz">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      {/* Investment */}
      <Reveal delay={0.15} data-id="element-768" data-mp="2vmx7g7j6fwhh">
        <div className="mt-10 overflow-hidden rounded-[2rem] bg-navy px-8 py-16 text-center text-paper md:px-16 md:py-20" data-id="element-769" data-mp="2vqb5j3kt5jj4">
          <div className="mx-auto max-w-2xl" data-id="element-770" data-mp="28138mx5jhlxv">
            <p className="text-sm uppercase tracking-[0.22em] text-gray-400" data-id="element-771" data-mp="282ecsy2wcvpi">
              Reader-to-Revenue Builds start at
            </p>
            <div className="mt-6 font-serif text-6xl font-semibold leading-none tracking-[-0.02em] text-sand md:text-8xl" data-id="element-772" data-mp="2h1hwa35z7d4j">
              $12,500
            </div>
            <div className="mx-auto mt-10 max-w-xl space-y-4 text-lg leading-relaxed text-gray-300" data-id="element-773" data-mp="2vx7ncfq0qgg4">
              <p data-id="element-774" data-mp="2qzfjqog0h5w3">
                Not a low-ticket funnel, a prettier author website, or a pile of
                bonus resources.
              </p>
              <p className="text-paper" data-id="element-775" data-mp="30oz3rxfgn5sj">
                One done-for-you system built behind the authority the book
                already created.
              </p>
              <p data-id="element-776" data-mp="3emxg6xa80s5e">
                The economics tend to make sense when one or two right-fit
                opportunities — advisory, consulting, a workshop, a cohort, a
                speaking engagement, certification, or team implementation —
                could justify it.
              </p>
            </div>
            <div className="mt-12 flex justify-center" data-id="element-777" data-mp="6f7oymt4f01m">
              <Cta variant="primary" showArrow onClick={openDiagnostic} className="px-10 py-4 text-lg" data-id="element-778" data-mp="6fr45vrdzaby">
                Get Your Reader-to-Revenue Score
              </Cta>
            </div>
          </div>
        </div>
      </Reveal>
    </SectionBand>;
}